import { isEmpty, omitBy } from 'lodash-es';
import { FILTER_QUERY_PARAMS } from 'site-modules/shared/constants/lease-deals/lease-deals';

/**
 * Adds missing values from selectedFilters to filters with count=0
 * Ignores certain filter types (payment, dueAtSigning)
 * @param {Object} selectedFilters - User selected filters
 * @param {Object} filters - Existing filters with data
 * @returns {Object} Updated filters with added missing values
 */
const addMissingSelectedFilters = (selectedFilters, filters) => {
  const ignoredKeys = [
    FILTER_QUERY_PARAMS.MONTHLY_PAYMENT,
    FILTER_QUERY_PARAMS.DUE_AT_SIGNING,
    FILTER_QUERY_PARAMS.DEALS,
    FILTER_QUERY_PARAMS.PAGE_NUM,
    FILTER_QUERY_PARAMS.SORT_BY,
  ];

  return Object.entries(selectedFilters).reduce((acc, [selectedFilter, filterValues]) => {
    if (ignoredKeys.includes(selectedFilter)) return acc;

    const existingValues = new Set((acc[selectedFilter] || []).map(item => item.value));
    const missingValues = filterValues.filter(value => !existingValues.has(value)).map(value => ({ value, count: 0 }));

    return {
      ...acc,
      [selectedFilter]: [...(acc[selectedFilter] || []), ...missingValues],
    };
  }, filters);
};

/**
 * Processes GraphQL facets: transforms keys and adds missing values
 * @param {Object} params - Processing parameters
 * @param {Object} params.selectedFilters - User selected filters
 * @param {Object} params.filterFacets - GraphQL facets to transform
 * @param {Object} [params.defaultFilters={}] - Default base filters
 * @returns {Object} Processed filters ready for UI
 */
export const processFilters = ({ selectedFilters, filterFacets, defaultFilters = {} }) => {
  const filters = { ...defaultFilters, ...filterFacets };
  return omitBy(addMissingSelectedFilters(selectedFilters, filters), isEmpty);
};
